import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Terminal } from '../components/Challenge/Terminal';
import { StandaloneLayout } from '../components/Layout/StandaloneLayout';
import { X } from 'lucide-react';

export const StandaloneTerminal: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const containerId = searchParams.get('containerId');

  useEffect(() => {
    if (!containerId) {
      navigate('/');
    }
  }, [containerId, navigate]);

  const handleClose = () => {
    window.close();
  };

  return (
    <StandaloneLayout>
      <div className="p-4">
        <div className="flex justify-end mb-4">
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-white transition-colors p-2 rounded-full hover:bg-gray-800"
            title="Close window"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <Terminal containerId={containerId} />
      </div>
    </StandaloneLayout>
  );
}; 